import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link, Stack, Typography } from '@mui/material';

import { HStack } from '../../Stack';

export type Routes = {
  title: string;
  to: React.ComponentProps<typeof RouterLink>['to'];
};

export interface LookoHeaderProps {
  children?: React.ReactNode;

  /**
   * 헤더 제목.
   */
  title: string;

  /**
   * 페이지 라우트 표시.
   */
  routes?: Routes[];

  tabList?: React.ReactNode;

  'data-testid'?: string;
}

/**
 * 페이지 메뉴 헤더.
 *
 * @package
 */
export const Header = ({ children, title, routes, tabList, 'data-testid': dataTestId }: LookoHeaderProps) => {
  return (
    <Stack
      borderBottom={1}
      borderTop={1}
      borderColor={theme => theme.palette.divider}
      position={'sticky'}
      top={0}
      bgcolor={'white'}
      zIndex={10}
    >
      <HStack p={2} alignItems={'center'} justifyContent={'space-between'} bgcolor={'white'}>
        <HStack spacing={1} alignItems={'center'} height={'32px'}>
          {routes?.length && (
            <nav>
              {routes?.map((v, idx) => (
                <HStack key={idx} spacing={1} alignItems={'center'}>
                  <Link
                    component={RouterLink}
                    variant="H1_Looko"
                    color={theme => theme.palette.grey[600]}
                    underline={'none'}
                    to={v.to}
                  >
                    {v.title}
                  </Link>

                  <KeyboardArrowRightIcon sx={theme => ({ width: 24, height: 24, color: theme.palette.grey[600] })} />
                </HStack>
              ))}
            </nav>
          )}

          <Typography variant="H1_Looko" component={'h1'} noWrap data-testid={dataTestId}>
            {title}
          </Typography>
        </HStack>

        {children}
      </HStack>
      {tabList}
    </Stack>
  );
};
